export default function urlToId(url: string): string {
  const [id = ""] = url.match(/[\d]{1,}$/) || [];

  return id;
}
